// @ts-nocheck
import business from "./business.json";
import menu from "./menu.json";
import services from "./services.json";

/**
 * Offline copy of Hotel Vivas: the business details, the menu and the room-service list.
 *
 * The API stays the source of truth. This is what the app shows when the API cannot be
 * reached or answers with nothing, so a guest who scans the QR code still gets the menu
 * instead of the "no business linked" screen.
 *
 * Taken verbatim from the live API on 2026-08-10 - unedited, so anything reading it
 * behaves exactly as it does with a live response:
 *
 *   business.json  GET /api/v1/business/data/2
 *   menu.json      GET /api/menu-item/business/2                  (16 categories, 172 items)
 *   services.json  GET /api/menu-item/room-service/business/2     (8 categories)
 *
 * To refresh, fetch those three from https://clickapp.win with the same bearer token the
 * slices use and overwrite the files. Photos are absolute URLs on clickapp.win, so they
 * still load while the API itself is unreachable; where one is missing MenuImage draws a
 * placeholder instead of a broken image.
 */

export const FALLBACK_BUSINESS = business;
export const FALLBACK_MENU = menu;
export const FALLBACK_SERVICES = services;

// The business the bundled data belongs to. Used when the id in the QR code turns out
// not to resolve, so the menu that gets shown and the business it is attributed to agree.
export const FALLBACK_BUSINESS_ID = String(business.id);

/** A response is only worth showing if it actually carries categories. */
export const hasCategories = (data) => Array.isArray(data) && data.length > 0;
